import React, { Component } from 'react';
import { connect } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';

import Sticky from 'Components/Sticky';
import {
    GET_GOOGLE_STUDIO_REPORT,
    GET_COMPANY_DATA,
    SAVE_USER_REPORT_UTILIZATION_EVENT
} from 'Constants/actionConstants';
import { VIMS_MODULE_ID, SEEKER } from 'Constants/commonConstants';
import { getUser, getCompanyType } from 'Utils/storage';
import classnames from 'classnames';
import ActionLoader from 'Components/ActionLoader';

class HolisticsDashboards extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: true,
            isDashboardsLoading: true,
            activeTab: '1',
            report_id: '',
            dashboards: []
        }
    }

    getDaaiDashboards = () => {
        const { dispatch } = this.props;
        const user = getUser();
        const isSeeker = getCompanyType() === SEEKER;
        if (!isSeeker) {
            this.setState({ isDashboardsLoading: false, isLoading: false, dashboards: [] });
            return;
        }
        this.setState({ isDashboardsLoading: true });
        dispatch({
            type: GET_COMPANY_DATA,
            isSeeker,
            params: {
                module: 'VIMS',
                module_id: VIMS_MODULE_ID,
                companyId: user.company_id,
                seekerCompanyId: user.company_id
            },
            onSuccess: (responseData) => {
                const dashboards = (responseData && responseData.dashboards) || [];
                this.setState({ isDashboardsLoading: false, dashboards }, () => {
                    if (dashboards.length > 0) {
                        this.toggle(dashboards[0].report_id, dashboards[0].report_id, dashboards[0].report_name);
                    } else {
                        this.setState({ isLoading: false });
                    }
                });
            },
            onError: () => {
                this.setState({ isDashboardsLoading: false, isLoading: false, dashboards: [] });
            }
        });
    }

    toggle = (activeTab, report_id , dashboardName) => {
        this.setState({ activeTab, report_id },() => {
            this.getDashboard();
        });
        this.handleOnClickForReport(dashboardName)
    }

    getDashboard = () => {
        const { dispatch } = this.props;

        dispatch({
            type: GET_GOOGLE_STUDIO_REPORT,
            params: {
                report_id: this.state.report_id
            }
        })
    }

    handleOnClickForReport = (report_name) => {
        const { dispatch } = this.props;
        dispatch({
            type: SAVE_USER_REPORT_UTILIZATION_EVENT,
            payload: {
                event_name: "on_click_of_report",
                report_name: report_name
            },
        });
    }

    render() {
        const { data } = this.props;
        const { activeTab, isDashboardsLoading, dashboards } = this.state;
        return (
            <Sticky activeLink={'holistic-dashboards'}>
                {(this.state.isLoading || isDashboardsLoading) && <ActionLoader fixed={true}></ActionLoader>}
                <Nav tabs className={'flex'} style={{'border': '1px solid lightgrey'}}>
                    {!isDashboardsLoading && dashboards.length === 0 && <NavItem style={{'textAlign': 'center'}}><NavLink disabled>No dashboards available</NavLink></NavItem>}
                    {
                        dashboards.map((dashboard) => (
                            <NavItem key={`dashboard-${dashboard.report_id}`} style={{'borderRight': '1px solid lightgrey', 'textAlign': 'center'}}>
                                <NavLink
                                    className={classnames('fBolder', { active: activeTab === dashboard.report_id })}
                                    onClick={() => {
                                        this.toggle(dashboard.report_id, dashboard.report_id, dashboard.report_name)
                                    }}
                                >
                                {dashboard.report_name}
                                </NavLink>
                            </NavItem>
                        ))
                    }
                </Nav>
                <TabContent activeTab={activeTab}>
                    {
                        data.report_id  && dashboards.map((dashboard) => (
                            <TabPane key={`dashboard-pane-${dashboard.report_id}`} tabId={dashboard.report_id}>
                                <iframe
                                    src={data.src}
                                    style={{width: "100%", height: 600}}
                                    frameBorder="0"
                                    onLoad={() => { this.setState({ isLoading: false }) }}
                                    title={data.report_name}
                                    allowFullScreen
                                >
                                </iframe>
                            </TabPane>
                        ))
                    }
                </TabContent>
            </Sticky>
        );
    }
    componentDidMount() {
        this.getDaaiDashboards();
    }
}

const mapStateToProps = ({common}) => {
  return {
    data: common.googleStudioReport || {}
  }
};


export default connect(mapStateToProps)(HolisticsDashboards);
